import $ from "jquery";

$(function () {
  var webStorage = function () {
    if (sessionStorage.getItem("access")) {
      /*
        2回目以降アクセス時の処理
      */
      $(".l-header-loading").addClass("is-active");
    } else {
      /*
        初回アクセス時の処理
      */
      sessionStorage.setItem("access", "true"); // sessionStorageにデータを保存
      $(".l-header-loading__animation").addClass("is-active"); // loadingアニメーションを表示
      setTimeout(function () {
        // ローディングを数秒後に非表示にする
        $(".l-header-loading").addClass("is-active");
        $(".l-header-loading__animation").removeClass("is-active");
      }, 0); // ローディングを表示する時間
    }
  };
  webStorage();
});
